import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UserActions } from 'src/app/model/useraction/useractions';
import { CosyAppStateDataControllerService } from 'src/app/service/controller/cosy-app-state-data-controller.service';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';

import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

@Component({
  selector: 'app-cosy-trigger',
  templateUrl: './cosy-trigger.component.html',
  styleUrls: ['./cosy-trigger.component.css']
})
export class CosyTriggerComponent implements OnInit {
  @Input() ie:InterfaceElement;
  @Output() switchToApp: EventEmitter<any> = new EventEmitter<any>();
  public captchaNotificationMsg: string = '';
  public triggerClass: string ;
  public disableTrigger : boolean = false;
  public captchaKey = '6LdkxjcUAAAAAJ05YyvFssGDxerWGMoJ0rAGelrS';
  
  constructor(private uxControllerService: UXControllerService, private cosyCommunicationControllerService: CosyCommunicationControllerService, private cosyAppStateDataControllerService: CosyAppStateDataControllerService) { }

  ngOnInit() {
    this.ie = this.uxControllerService.senseLanguageCode(this.ie);
    this.disableTrigger = !this.ie.Attributes.Enabled;

    if(this.ie.isFromRibbon){
      this.triggerClass = 'btn btn-secondary btn-sm ribbonItemSet';
    }
    else {
      this.triggerClass = 'btn btn-secondary btn-sm mb-2';
    }

    if (this.ie.TemplateID == "23d85163-dc21-46d8-afa7-eb4d783bdda2" || this.ie.TemplateID == "87479c29-fea5-451c-8967-98e6aad6aba3") this.triggerClass = this.triggerClass + ' float-right languageTriggers';
    if (this.ie.TemplateID == "3379634b-c9e7-49b6-8cdd-c733f09734bd" || this.ie.TemplateID == "8ab6302a-dca9-4436-afab-b60f6a7e7a9b") this.triggerClass = this.triggerClass + ' languageTriggers';
  }

  fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[]) {
    
    if (userActionID != null) {
      let isAPOS: boolean = this.cosyAppStateDataControllerService.isActionProcessOnServer(userActionID, this.ie.UserActions);
      
      if (userActionID == UserActions.ShowRunTimeKeysUA && !isAPOS){
        this.getRuntimeKeys();
      }
      else if(userActionID == UserActions.SwitchToBackendAppUA && !isAPOS){
        this.switchToAppTrigger();
      }
      else {
        this.uxControllerService.fetchIEUserAction(userActionID,this.ie,value,attributeKey,additionalAttributes,additionalInterfaceElements,null,null)
      }
      
    }
  }

  switchToAppTrigger(){
    this.switchToApp.emit();
  }


  getRuntimeKeys() {
    this.cosyCommunicationControllerService.getRuntimeKeys(this.uxControllerService.appSessionID).subscribe(
      res => {
        console.log(res);
      },
      error => console.error('Error in recieving Response Token : ', error),
      () => { }
    );
  }


  captchaSubmit(captchaResponse: string, ie: InterfaceElement): void {
    this.captchaNotificationMsg = 'Das Captcha wurde schon gelöst';
    this.fetchIEUserAction(ie.Attributes.OnSelectUAID, null, null, null, null);
    grecaptcha.reset();
  }
  
  captchaExecuteMethod() {
    this.captchaNotificationMsg = '';
    grecaptcha.execute();
  }

}
